(function () {
  function emitNavEvent(eventName, detail) {
    var payload = Object.assign({ event: eventName }, detail || {});


    document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
  }

  function closeItem(item) {
    if (!item) return;

    var trigger = item.querySelector("[data-el-click-menu-trigger]");
    var panel = item.querySelector("[data-el-click-menu-panel]");

    item.classList.remove("is-open");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (panel) panel.hidden = true;
  }

  function loadPanelImages(panel) {
    if (!panel) return;

    panel.querySelectorAll("img[data-el-menu-image-src]").forEach(function (image) {
      if (image.getAttribute("src")) return;
      image.setAttribute("src", image.getAttribute("data-el-menu-image-src"));
    });
  }

  function openItem(menu, item) {
    menu.querySelectorAll("[data-el-click-menu-item].is-open").forEach(function (openMenuItem) {
      if (openMenuItem !== item) closeItem(openMenuItem);
    });

    var trigger = item.querySelector("[data-el-click-menu-trigger]");
    var panel = item.querySelector("[data-el-click-menu-panel]");

    item.classList.add("is-open");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    if (panel) {
      loadPanelImages(panel);
      panel.hidden = false;
    }

    emitNavEvent("el_nav_menu_open", {
      nav_category: trigger ? trigger.getAttribute("data-el-menu-title") : "",
    });
  }

  function initMenu(menu) {
    if (menu.hasAttribute("data-el-click-menu-ready")) return;
    menu.setAttribute("data-el-click-menu-ready", "true");

    menu.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-el-click-menu-trigger]");
      var link = event.target.closest("[data-el-menu-link]");

      if (trigger && menu.contains(trigger)) {
        var item = trigger.closest("[data-el-click-menu-item]");
        var isOpen = item && item.classList.contains("is-open");
        event.preventDefault();

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(menu, item);
        }
      }

      if (link && menu.contains(link)) {
        emitNavEvent("el_nav_menu_link_click", {
          nav_category: link.getAttribute("data-el-menu-parent") || "",
          nav_label: link.textContent.trim(),
          nav_url: link.getAttribute("href") || "",
        });
      }
    });

    menu.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;

      var openItemElement = menu.querySelector("[data-el-click-menu-item].is-open");
      if (!openItemElement) return;

      var trigger = openItemElement.querySelector("[data-el-click-menu-trigger]");
      closeItem(openItemElement);
      if (trigger) trigger.focus();
    });

    document.addEventListener("click", function (event) {
      if (menu.contains(event.target)) return;

      menu.querySelectorAll("[data-el-click-menu-item].is-open").forEach(closeItem);
    });
  }

  function init() {
    document.querySelectorAll("[data-el-click-menu]").forEach(initMenu);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
